import React from 'react';
import { Helmet } from 'react-helmet-async';

interface SeoLayoutProps {
  children: React.ReactNode;
  pageProps?: any;
}

// Provides a default SEO tag set across all pages (Gatsby v3 friendly)
export const SeoLayout: React.FC<SeoLayoutProps> = ({ children, pageProps }) => {
  const siteBase = 'https://y3smilesdental.com.au';
  const pathname = pageProps?.location?.pathname || '/';
  const canonical = `${siteBase}${pathname}`;

  return (
    <>
      <Helmet>
        <link rel="canonical" href={canonical} />
        <meta property="og:url" content={canonical} />
      </Helmet>
      {children}
    </>
  );
};

export default SeoLayout;
